import { defineComponent as _defineComponent } from 'vue'
import { computed } from "@nuxtjs/composition-api";

import { EXPERIMENTS_TRENDING_POST_CAROUSEL } from "@/utils/experiments/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatorShopPostsTab',
  props: {
  hasProductsSets: { type: Boolean, default: false },
  hasPosts: { type: Boolean, default: false },
  profileId: { type: String, required: true },
  displayName: { type: String, required: true },
  isVisible: { type: Boolean, default: false },
},
  setup(__props) {



const trendingPostCarouselExperiment = computed(() => EXPERIMENTS_TRENDING_POST_CAROUSEL);

return { __sfc: true,trendingPostCarouselExperiment }
}

})